import axios from '@/libs/api.request';

export const getDistributionStationProductStoreList = data => {
    return axios.request({
        url: 'api/distributionStationProductStore/getDistributionStationProductStoreList',
        data: data,
        method: 'post'
    });
};

export const getDistributionStationPreSaleDeliveryCheckList = data => {
    return axios.request({
        url: 'api/distributionStationProductStore/deliveryCheck/getDistributionStationPreSaleDeliveryCheckList',
        data: data,
        method: 'post'
    });
};

export const getDistributionStationCurSaleDeliveryCheckList = data => {
    return axios.request({
        url: 'api/distributionStationProductStore/deliveryCheck/getDistributionStationCurSaleDeliveryCheckList',
        data: data,
        method: 'post'
    });
};

export const preSaleSaveDistributionStationDiscard = data => {
    return axios.request({
        url: 'api/distributionStationProductStore/discard/preSale/preSaleSaveDistributionStationDiscard',
        data: data,
        method: 'post'
    });
};

export const curSaleSaveDistributionStationDiscard = data => {
    return axios.request({
        url: 'api/distributionStationProductStore/discard/curSale/curSaleSaveDistributionStationDiscard',
        data: data,
        method: 'post'
    });
};
